export const noop = () => undefined;

export const clamp = (min: number, value: number, max: number) => {
  const higher = Math.min(value, max);
  return Math.max(min, higher);
};

export const getUserPreferredLang = () => {
  const supported = ['nb', 'no', 'dk', 'da', 'sv', 'fi', 'en'];
  const supportedRegex = new RegExp(`(${supported.join('|')})`, 'gi');
  const found = navigator.languages.find((locale) => locale.match(supportedRegex));

  const lang = found?.split('-')[0]; // nb-NO => nb

  const NORMALIZED_LANG_ATTR = {
    nb: 'no',
    no: 'no',
    dk: 'dk',
    da: 'dk',
    sv: 'sv',
    fi: 'fi',
    en: 'en',
  } as const;

  return NORMALIZED_LANG_ATTR[lang ?? 'en'];
};
